export const FAVORITES_INI_STATE = {
    data: [],
};